import React from 'react';

export default function Marketplace() {
  return (
    <div style={{ padding: 20 }}>
      <h1>Marketplace</h1>
      <p>List deals, buy deals, and manage marketplace activity.</p>
    </div>
  );
}
